type StringMetadata = { context: string, english: string };

export const TokenizedStrings: Record<string, StringMetadata> = {
    UnknownError: {
        context: "Displayed in error alerts",
        english: "An unknown error occurred. Please contact support if the problem persists: https://www.voltagevolunteering.com/contact-us"
    }
}